import _classCallCheck from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _slicedToArray from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.promise.finally.js";
import _regeneratorRuntime from "/codebuild/output/src642544548/src/github.com/swarthmore-web/dash-gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";

/**
 *
 * client
 *
 */
var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};

var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};

import { GRAPHQL_TRANSPORT_WS_PROTOCOL, CloseCode, MessageType, parseMessage, stringifyMessage } from './common.mjs';
import { isObject, limitCloseReason } from './utils.mjs';
/** This file is the entry point for browsers, re-export common elements. */

export * from './common.mjs';
/**
 * Creates a disposable GraphQL over WebSocket client.
 *
 * @category Client
 */

export function createClient(options) {
  var url = options.url,
      connectionParams = options.connectionParams,
      _options$lazy = options.lazy,
      lazy = _options$lazy === void 0 ? true : _options$lazy,
      _options$onNonLazyErr = options.onNonLazyError,
      onNonLazyError = _options$onNonLazyErr === void 0 ? console.error : _options$onNonLazyErr,
      _options$lazyCloseTim = options.lazyCloseTimeout,
      lazyCloseTimeoutMs = _options$lazyCloseTim === void 0 ? 0 : _options$lazyCloseTim,
      _options$keepAlive = options.keepAlive,
      keepAlive = _options$keepAlive === void 0 ? 0 : _options$keepAlive,
      disablePong = options.disablePong,
      _options$connectionAc = options.connectionAckWaitTimeout,
      connectionAckWaitTimeout = _options$connectionAc === void 0 ? 0 : _options$connectionAc,
      _options$retryAttempt = options.retryAttempts,
      retryAttempts = _options$retryAttempt === void 0 ? 5 : _options$retryAttempt,
      _options$retryWait = options.retryWait,
      retryWait = _options$retryWait === void 0 ? /*#__PURE__*/function () {
    var _randomisedExponentialBackoff = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retries) {
      var retryDelay, i;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              retryDelay = 1000; // start with 1s delay

              // start with 1s delay
              for (i = 0; i < retries; i++) {
                retryDelay *= 2;
              }

              _context.next = 4;
              return new Promise(function (resolve) {
                return setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
                Math.floor(Math.random() * (3000 - 300) + 300));
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function randomisedExponentialBackoff(_x) {
      return _randomisedExponentialBackoff.apply(this, arguments);
    }

    return randomisedExponentialBackoff;
  }() : _options$retryWait,
      _options$shouldRetry = options.shouldRetry,
      shouldRetry = _options$shouldRetry === void 0 ? isLikeCloseEvent : _options$shouldRetry,
      isFatalConnectionProblem = options.isFatalConnectionProblem,
      on = options.on,
      webSocketImpl = options.webSocketImpl,
      _options$generateID = options.generateID,
      generateID = _options$generateID === void 0 ? function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  } : _options$generateID,
      replacer = options.jsonMessageReplacer,
      reviver = options.jsonMessageReviver;
  var ws;

  if (webSocketImpl) {
    if (!isWebSocket(webSocketImpl)) {
      throw new Error('Invalid WebSocket implementation provided');
    }

    ws = webSocketImpl;
  } else if (typeof WebSocket !== 'undefined') {
    ws = WebSocket;
  } else if (typeof global !== 'undefined') {
    ws = global.WebSocket || // @ts-expect-error: Support more browsers
    global.MozWebSocket;
  } else if (typeof window !== 'undefined') {
    ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
  }

  if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  var WebSocketImpl = ws; // websocket status emitter, subscriptions are handled differently

  var emitter = function () {
    var message = function () {
      var listeners = {};
      return {
        on: function on(id, listener) {
          listeners[id] = listener;
          return function () {
            delete listeners[id];
          };
        },
        emit: function emit(message) {
          var _a;

          if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 ? void 0 : _a.call(listeners, message);
        }
      };
    }();

    var listeners = {
      connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [on.connecting] : [],
      opened: (on === null || on === void 0 ? void 0 : on.opened) ? [on.opened] : [],
      connected: (on === null || on === void 0 ? void 0 : on.connected) ? [on.connected] : [],
      ping: (on === null || on === void 0 ? void 0 : on.ping) ? [on.ping] : [],
      pong: (on === null || on === void 0 ? void 0 : on.pong) ? [on.pong] : [],
      message: (on === null || on === void 0 ? void 0 : on.message) ? [message.emit, on.message] : [message.emit],
      closed: (on === null || on === void 0 ? void 0 : on.closed) ? [on.closed] : [],
      error: (on === null || on === void 0 ? void 0 : on.error) ? [on.error] : []
    };
    return {
      onMessage: message.on,
      on: function on(event, listener) {
        var l = listeners[event];
        l.push(listener);
        return function () {
          l.splice(l.indexOf(listener), 1);
        };
      },
      emit: function emit(event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // we copy the listeners so that unlistens dont "pull the rug under our feet"
        for (var _i = 0, _arr = _toConsumableArray(listeners[event]); _i < _arr.length; _i++) {
          var listener = _arr[_i];
          // @ts-expect-error: The args should fit
          listener.apply(void 0, args);
        }
      }
    };
  }(); // invokes the callback either when an error or closed event is emitted,
  // first one that gets called prevails, other emissions are ignored


  function errorOrClosed(cb) {
    var listening = [// errors are fatal and more critical than close events, throw them first
    emitter.on('error', function (err) {
      listening.forEach(function (unlisten) {
        return unlisten();
      });
      cb(err);
    }), // closes can be graceful and not fatal, throw them second (if error didnt throw)
    emitter.on('closed', function (event) {
      listening.forEach(function (unlisten) {
        return unlisten();
      });
      cb(event);
    })];
  }

  var connecting,
      locks = 0,
      lazyCloseTimeout,
      retrying = false,
      retries = 0,
      disposed = false;

  function connect() {
    return _connect.apply(this, arguments);
  }
  /**
   * Checks the `connect` problem and evaluates if the client should retry.
   */


  function _connect() {
    _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var _yield, _yield2, socket, throwOnClose, release, released;

      return _regeneratorRuntime.wrap(function _callee10$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              // clear the lazy close timeout immediatelly so that close gets debounced
              // see: https://github.com/enisdenjo/graphql-ws/issues/388
              clearTimeout(lazyCloseTimeout);
              _context11.next = 3;
              return connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise(function (connected, denied) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                  var socket, connectionAckTimeout, queuedPing, enqueuePing, acknowledged;
                  return _regeneratorRuntime.wrap(function _callee9$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          enqueuePing = function _enqueuePing() {
                            if (isFinite(keepAlive) && keepAlive > 0) {
                              clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)

                              // in case where a pong was received before a ping (this is valid behaviour)
                              queuedPing = setTimeout(function () {
                                if (socket.readyState === WebSocketImpl.OPEN) {
                                  socket.send(stringifyMessage({
                                    type: MessageType.Ping
                                  }));
                                  emitter.emit('ping', false, undefined);
                                }
                              }, keepAlive);
                            }
                          };

                          if (!retrying) {
                            _context10.next = 8;
                            break;
                          }

                          _context10.next = 4;
                          return retryWait(retries);

                        case 4:
                          if (locks) {
                            _context10.next = 7;
                            break;
                          }

                          connecting = undefined;
                          return _context10.abrupt("return", denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                          }));

                        case 7:
                          retries++;

                        case 8:
                          emitter.emit('connecting', retrying);
                          _context10.t0 = WebSocketImpl;

                          if (!(typeof url === 'function')) {
                            _context10.next = 16;
                            break;
                          }

                          _context10.next = 13;
                          return url();

                        case 13:
                          _context10.t1 = _context10.sent;
                          _context10.next = 17;
                          break;

                        case 16:
                          _context10.t1 = url;

                        case 17:
                          _context10.t2 = _context10.t1;
                          _context10.t3 = GRAPHQL_TRANSPORT_WS_PROTOCOL;
                          socket = new _context10.t0(_context10.t2, _context10.t3);
                          errorOrClosed(function (errOrEvent) {
                            connecting = undefined;
                            clearTimeout(connectionAckTimeout);
                            clearTimeout(queuedPing);
                            denied(errOrEvent);

                            if (errOrEvent instanceof TerminatedCloseEvent) {
                              socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below

                              // close event is artificial and emitted manually, see `Client.terminate()` below
                              socket.onerror = null;
                              socket.onclose = null;
                            }
                          });

                          socket.onerror = function (err) {
                            return emitter.emit('error', err);
                          };

                          socket.onclose = function (event) {
                            return emitter.emit('closed', event);
                          };

                          socket.onopen = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                            var payload;
                            return _regeneratorRuntime.wrap(function _callee8$(_context9) {
                              while (1) {
                                switch (_context9.prev = _context9.next) {
                                  case 0:
                                    _context9.prev = 0;
                                    emitter.emit('opened', socket);

                                    if (!(typeof connectionParams === 'function')) {
                                      _context9.next = 8;
                                      break;
                                    }

                                    _context9.next = 5;
                                    return connectionParams();

                                  case 5:
                                    _context9.t0 = _context9.sent;
                                    _context9.next = 9;
                                    break;

                                  case 8:
                                    _context9.t0 = connectionParams;

                                  case 9:
                                    payload = _context9.t0;

                                    if (!(socket.readyState !== WebSocketImpl.OPEN)) {
                                      _context9.next = 12;
                                      break;
                                    }

                                    return _context9.abrupt("return");

                                  case 12:
                                    socket.send(stringifyMessage(payload ? {
                                      type: MessageType.ConnectionInit,
                                      payload: payload
                                    } : {
                                      type: MessageType.ConnectionInit // payload is completely absent if not provided

                                    }, replacer));

                                    if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) {
                                      connectionAckTimeout = setTimeout(function () {
                                        socket.close(CloseCode.ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                                      }, connectionAckWaitTimeout);
                                    }

                                    enqueuePing(); // enqueue ping (noop if disabled)

                                    _context9.next = 21;
                                    break;

                                  case 17:
                                    _context9.prev = 17;
                                    _context9.t1 = _context9["catch"](0);
                                    emitter.emit('error', _context9.t1);
                                    socket.close(CloseCode.InternalClientError, limitCloseReason(_context9.t1 instanceof Error ? _context9.t1.message : new Error(_context9.t1).message, 'Internal client error'));

                                  case 21:
                                  case "end":
                                    return _context9.stop();
                                }
                              }
                            }, _callee8, null, [[0, 17]]);
                          }));
                          acknowledged = false;

                          socket.onmessage = function (_ref7) {
                            var data = _ref7.data;

                            try {
                              var message = parseMessage(data, reviver);
                              emitter.emit('message', message);

                              if (message.type === 'ping' || message.type === 'pong') {
                                emitter.emit(message.type, true, message.payload); // received

                                // received
                                if (message.type === 'pong') {
                                  enqueuePing(); // enqueue next ping (noop if disabled)
                                } else if (!disablePong) {
                                  // respond with pong on ping
                                  socket.send(stringifyMessage(message.payload ? {
                                    type: MessageType.Pong,
                                    payload: message.payload
                                  } : {
                                    type: MessageType.Pong // payload is completely absent if not provided

                                  }));
                                  emitter.emit('pong', false, message.payload);
                                }

                                return; // ping and pongs can be received whenever
                              }

                              if (acknowledged) return; // already connected and acknowledged

                              // already connected and acknowledged
                              if (message.type !== MessageType.ConnectionAck) throw new Error("First message cannot be of type ".concat(message.type));
                              clearTimeout(connectionAckTimeout);
                              acknowledged = true;
                              emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged

                              // connected = socket opened + acknowledged
                              retrying = false; // future lazy connects are not retries

                              // future lazy connects are not retries
                              retries = 0; // reset the retries on connect

                              // reset the retries on connect
                              connected([socket, new Promise(function (_, reject) {
                                return errorOrClosed(reject);
                              })]);
                            } catch (err) {
                              socket.onmessage = null; // stop reading messages as soon as reading breaks once

                              // stop reading messages as soon as reading breaks once
                              emitter.emit('error', err);
                              socket.close(CloseCode.BadResponse, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                            }
                          };

                        case 26:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee9);
                }))();
              });

            case 3:
              _yield = _context11.sent;
              _yield2 = _slicedToArray(_yield, 2);
              socket = _yield2[0];
              throwOnClose = _yield2[1];

              if (!(socket.readyState === WebSocketImpl.CLOSING)) {
                _context11.next = 10;
                break;
              }

              _context11.next = 10;
              return throwOnClose;

            case 10:
              release = function release() {// releases this connection
              };

              released = new Promise(function (resolve) {
                return release = resolve;
              });
              return _context11.abrupt("return", [socket, release, Promise.race([// wait for
              released.then(function () {
                if (!locks) {
                  // and if no more locks are present, complete the connection
                  var complete = function complete() {
                    return socket.close(1000, 'Normal Closure');
                  };

                  if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) {
                    // if the keepalive is set, allow for the specified calmdown time and
                    // then complete if the socket is still open.
                    lazyCloseTimeout = setTimeout(function () {
                      if (socket.readyState === WebSocketImpl.OPEN) complete();
                    }, lazyCloseTimeoutMs);
                  } else {
                    // otherwise complete immediately
                    complete();
                  }
                }
              }), // or
              throwOnClose])]);

            case 13:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee10);
    }));
    return _connect.apply(this, arguments);
  }

  function shouldRetryConnectOrThrow(errOrCloseEvent) {
    // some close codes are worth reporting immediately
    if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [CloseCode.InternalServerError, CloseCode.InternalClientError, CloseCode.BadRequest, CloseCode.BadResponse, CloseCode.Unauthorized, // CloseCode.Forbidden, might grant access out after retry
    CloseCode.SubprotocolNotAcceptable, // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
    // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
    CloseCode.SubscriberAlreadyExists, CloseCode.TooManyInitialisationRequests // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(errOrCloseEvent.code))) throw errOrCloseEvent; // client was disposed, no retries should proceed regardless

    if (disposed) return false; // normal closure (possibly all subscriptions have completed)
    // if no locks were acquired in the meantime, shouldnt try again

    if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0; // retries are not allowed or we tried to many times, report error

    if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent; // throw non-retryable connection problems

    if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent; // @deprecated throw fatal connection problems immediately

    if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent; // looks good, start retrying

    return retrying = true;
  } // in non-lazy (hot?) mode always hold one connection lock to persist the socket


  if (!lazy) {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$connect, _yield$connect2, throwOnClose;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              locks++;

            case 1:
              _context2.prev = 1;
              _context2.next = 4;
              return connect();

            case 4:
              _yield$connect = _context2.sent;
              _yield$connect2 = _slicedToArray(_yield$connect, 3);
              throwOnClose = _yield$connect2[2];
              _context2.next = 9;
              return throwOnClose;

            case 9:
              _context2.next = 21;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              _context2.prev = 13;

              if (shouldRetryConnectOrThrow(_context2.t0)) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("return");

            case 16:
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t1 = _context2["catch"](13);
              return _context2.abrupt("return", onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(_context2.t1));

            case 21:
              _context2.next = 1;
              break;

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 11], [13, 18]]);
    }))();
  }

  function subscribe(payload, sink) {
    var id = generateID(payload);

    var done = false,
        errored = false,
        releaser = function releaser() {
      // for handling completions before connect
      locks--;
      done = true;
    };

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ret;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              locks++;

            case 1:
              _context4.prev = 1;
              return _context4.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var _yield$connect3, _yield$connect4, socket, release, waitForReleaseOrThrowOnClose, unlisten;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return connect();

                      case 2:
                        _yield$connect3 = _context3.sent;
                        _yield$connect4 = _slicedToArray(_yield$connect3, 3);
                        socket = _yield$connect4[0];
                        release = _yield$connect4[1];
                        waitForReleaseOrThrowOnClose = _yield$connect4[2];

                        if (!done) {
                          _context3.next = 9;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: release()
                        });

                      case 9:
                        unlisten = emitter.onMessage(id, function (message) {
                          switch (message.type) {
                            case MessageType.Next:
                              {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                              }

                            case MessageType.Error:
                              {
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                              }

                            case MessageType.Complete:
                              {
                                done = true;
                                releaser(); // release completes the sink

                                return;
                              }
                          }
                        });
                        socket.send(stringifyMessage({
                          id: id,
                          type: MessageType.Subscribe,
                          payload: payload
                        }, replacer));

                        releaser = function releaser() {
                          if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                            socket.send(stringifyMessage({
                              id: id,
                              type: MessageType.Complete
                            }, replacer));
                          locks--;
                          done = true;
                          release();
                        }; // either the releaser will be called, connection completed and
                        // the promise resolved or the socket closed and the promise rejected.
                        // whatever happens though, we want to stop listening for messages


                        _context3.next = 14;
                        return waitForReleaseOrThrowOnClose.finally(unlisten);

                      case 14:
                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 15:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })(), "t0", 3);

            case 3:
              _ret = _context4.t0;

              if (!(typeof _ret === "object")) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", _ret.v);

            case 6:
              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t1 = _context4["catch"](1);

              if (shouldRetryConnectOrThrow(_context4.t1)) {
                _context4.next = 12;
                break;
              }

              return _context4.abrupt("return");

            case 12:
              _context4.next = 1;
              break;

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    }))().then(function () {
      // delivering either an error or a complete terminates the sequence
      if (!errored) sink.complete();
    }) // resolves on release or normal closure
    .catch(function (err) {
      sink.error(err);
    }); // rejects on close events and errors


    return function () {
      // dispose only of active subscriptions
      if (!done) releaser();
    };
  }

  return {
    on: emitter.on,
    subscribe: subscribe,
    iterate: function iterate(request) {
      var pending = [];
      var deferred = {
        done: false,
        error: null,
        resolve: function resolve() {// noop
        }
      };
      var dispose = subscribe(request, {
        next: function next(val) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          pending.push(val);
          deferred.resolve();
        },
        error: function error(err) {
          deferred.done = true;
          deferred.error = err;
          deferred.resolve();
        },
        complete: function complete() {
          deferred.done = true;
          deferred.resolve();
        }
      });

      var iterator = function iterator() {
        return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function iterator_1() {
          return _regeneratorRuntime.wrap(function iterator_1$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (pending.length) {
                    _context5.next = 3;
                    break;
                  }

                  _context5.next = 3;
                  return __await(new Promise(function (resolve) {
                    return deferred.resolve = resolve;
                  }));

                case 3:
                  if (!pending.length) {
                    _context5.next = 10;
                    break;
                  }

                  _context5.next = 6;
                  return __await(pending.shift());

                case 6:
                  _context5.next = 8;
                  return _context5.sent;

                case 8:
                  _context5.next = 3;
                  break;

                case 10:
                  if (!deferred.error) {
                    _context5.next = 12;
                    break;
                  }

                  throw deferred.error;

                case 12:
                  if (!deferred.done) {
                    _context5.next = 16;
                    break;
                  }

                  _context5.next = 15;
                  return __await(void 0);

                case 15:
                  return _context5.abrupt("return", _context5.sent);

                case 16:
                  _context5.next = 0;
                  break;

                case 18:
                case "end":
                  return _context5.stop();
              }
            }
          }, iterator_1);
        }));
      }();

      iterator.throw = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(err) {
          return _regeneratorRuntime.wrap(function _callee5$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                  }

                  return _context6.abrupt("return", {
                    done: true,
                    value: undefined
                  });

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }();

      iterator.return = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dispose();
                return _context7.abrupt("return", {
                  done: true,
                  value: undefined
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }));
      return iterator;
    },
    dispose: function dispose() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _yield$connecting, _yield$connecting2, socket;

        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                disposed = true;

                if (!connecting) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 4;
                return connecting;

              case 4:
                _yield$connecting = _context8.sent;
                _yield$connecting2 = _slicedToArray(_yield$connecting, 1);
                socket = _yield$connecting2[0];
                socket.close(1000, 'Normal Closure');

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7);
      }))();
    },
    terminate: function terminate() {
      if (connecting) {
        // only if there is a connection
        emitter.emit('closed', new TerminatedCloseEvent());
      }
    }
  };
}
/**
 * A syntetic close event `4499: Terminated` is issued to the current to immediately
 * close the connection without waiting for the one coming from `WebSocket.onclose`.
 *
 * Terminating is not considered fatal and a connection retry will occur as expected.
 *
 * Useful in cases where the WebSocket is stuck and not emitting any events;
 * can happen on iOS Safari, see: https://github.com/enisdenjo/graphql-ws/discussions/290.
 */

export var TerminatedCloseEvent = /*#__PURE__*/function (_Error) {
  _inherits(TerminatedCloseEvent, _Error);

  var _super = _createSuper(TerminatedCloseEvent);

  function TerminatedCloseEvent() {
    var _this;

    _classCallCheck(this, TerminatedCloseEvent);

    _this = _super.apply(this, arguments);
    _this.name = 'TerminatedCloseEvent';
    _this.message = '4499: Terminated';
    _this.code = 4499;
    _this.reason = 'Terminated';
    _this.wasClean = false;
    return _this;
  }

  return TerminatedCloseEvent;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function isLikeCloseEvent(val) {
  return isObject(val) && 'code' in val && 'reason' in val;
}

function isFatalInternalCloseCode(code) {
  if ([1000, 1001, 1006, 1005, 1012, 1013, 1014 // Bad Gateway
  ].includes(code)) return false; // all other internal errors are fatal

  return code >= 1000 && code <= 1999;
}

function isWebSocket(val) {
  return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}